import { cn } from '@/lib/utils';
import { rotuloPrazo, useSlaPrazos } from '@/hooks/useSla';
import { TempoTriagemBadge } from '@/components/kanban/TempoTriagemBadge';

/* A coluna Prazo das triagens (Douglas 24/10/2026): o prazo de cada pedido pela
   régua do banco, o mesmo número que a trava usa. Estourado é danger (trava);
   menos de 1 h é bordô (dívida chegando); no prazo não tem cor. Coluna sem SLA
   na tabela continua com o tempo na fila de antes. */
export function PrazoSlaBadge({ pedidoId, coluna, entradaColunaEm, prazoHoras, dataAgendamento, className }: {
  pedidoId: string; coluna: string | null | undefined; entradaColunaEm: string | null | undefined;
  prazoHoras: number | 'agendamento'; dataAgendamento?: string | null; className?: string;
}) {
  const { data } = useSlaPrazos(coluna);
  const p = data?.[pedidoId];
  if (!p) return <TempoTriagemBadge entradaColunaEm={entradaColunaEm} prazoHoras={prazoHoras} dataAgendamento={dataAgendamento} className={className} />;
  const cobrado = p.obs === 'cobrado_hoje';
  const semAgenda = p.obs === 'sem_agenda';
  const estado = cobrado ? 'ok' : p.estourado ? 'estourado' : p.restam_min <= 60 ? 'perto' : 'ok';
  return (
    <span
      className={cn('inline-flex max-w-full items-center gap-1 overflow-hidden whitespace-nowrap text-[11px] tabular-nums',
        estado === 'estourado' ? 'font-bold text-danger' : estado === 'perto' ? 'font-bold text-primary' : 'font-semibold text-muted-foreground',
        className)}
      title={`${rotuloPrazo(p.restam_min)} · prazo da fila: ${p.prazo}${cobrado ? ' · já cobrado hoje, volta amanhã às 9h' : ''}`}
    >
      {estado !== 'ok' && <span className={cn('h-[5px] w-[5px] flex-shrink-0 rounded-full', estado === 'estourado' ? 'bg-danger' : 'bg-primary')} />}
      <span className="min-w-0 truncate">{cobrado ? 'cobrado hoje' : semAgenda ? 'sem agenda' : rotuloPrazo(p.restam_min)}</span>
    </span>
  );
}
